<div class="campaign_page" #campaignPage [attr.data-is-component]="isComponent">
  <app-credential-header
    [headerBackground]="headerBackground"
    [headerTextColor]="headerTextColor"
    [logoCampaign]="logoCampaign"
  ></app-credential-header>
  <div
    class="container d-flex justify-content-center align-items-center"
    [style.background]="mainBackground"
  >
    <div class="row w-100 content">
      <app-credentials-one
        [selectTextOrImage]="selectTextOrImage"
        [textCampaign]="textCampaign"
        [imageCampaign]="imageCampaign"
        [mainBackground]="mainBackground"
        [diseingMobile]="true"
        [inputFullNameDisabled]="true"
        [activeButton]="false"
        [title]="credentialTitle"
        [formBackground]="credentialFormBackground"
        [design]="credentialDesign"
        [buttonUploadProfileBackground]="credentialButtonUpload"
        [buttonGenerateCredentialBackground]="credentialButtonGenerate"
        [buttonUploadStyle]="credentialButtonUploadStyle"
        [buttonGenerateStyle]="credentialButtonGenerateStyle"
        [image]="credentialImage"
      ></app-credentials-one>
    </div>
  </div>
  <app-credential-footer
    [logoCampaign]="logoCampaign"
    [footerBackground]="footerBackground"
    [footerTextColor]="footerTextColor"
  ></app-credential-footer>
</div>
